module.exports = __webpack_public_path__ + "static/image/noval-related.svg?86ebe0d5669858f67fdba0b44643fdc4";